import useMinerPortsRepository from "@components/Pages/Machines/MinerRow/MinerPorts/MinerPorts.repository";
import {
  IReproxyLinkEvent,
  ReproxyLinkRemoveEventTag,
} from "@components/Pages/Machines/MinerRow/minerReducer";
import useMinerReproxyPortsCache from "@components/Pages/Machines/MinersTable/Miners.utils";
import { useGlobalNotifs } from "@utils/hooks/useGlobalNotifs";
import { useToasts } from "@utils/hooks/useToasts";
import { SITE_KIND } from "../../config";
import { useState } from "react";

interface UseMinerPortsProps {
  onPortChanged(
    port: number,
    prevPort: number,
    minerId: number,
  ): void;
}

export default function useMinerPorts({ onPortChanged }: UseMinerPortsProps) {
  const { error } = useToasts();
  const { onLoader } = useGlobalNotifs();
  const [isPortLoading, setPortLoading] = useState(false);

  const portRepo = useMinerPortsRepository();
  const minerPortsCache = useMinerReproxyPortsCache();

  const createPortAndOpen = async (id: number, prevPort: number) => {
    onLoader(true);
    await createAndOpenPort(id, prevPort);
    onLoader(false);
  };

  function getMinerPortUrl(port: number): string {
    return `https://re${port}.${SITE_KIND?.toLowerCase()}.com`;
  }
  // function openMinerPort(port: number) {
  //   window.open(getMinerPortUrl(port));
  // }

  async function createAndOpenPort(minerId: number, prevPort: number) {
    setPortLoading(true);
    const response = await portRepo.create.request(minerId);
    setPortLoading(false);
    if (response && response.Status === "success") {
      if (response.Record.Port > 0) {
        //updateProxyLink(response.Record.Port);
        minerPortsCache.set(minerId, response.Record.Port, Date.now());
        if (prevPort !== response.Record.Port) {
          onPortChanged(response.Record.Port, prevPort, minerId);
        }
        window.open(getMinerPortUrl(response.Record.Port));
      } else {
        if ((response.Record as any).Message) {
          error((response.Record as any).Message);
        } else {
          error("Отключено");
        }
      }
    } else {
      error(response?.Message ?? "Create port error");
    }
  }

  async function deleteMinerPort(minerId: number, port: number) {
    onLoader(true);
    minerPortsCache.remove(minerId);
    const result = await portRepo.remove.request(port);
    if (!result || result.Status === "error") {
      error(result?.Message ?? "Unknown error");
    }
    onLoader(false);
    document.dispatchEvent(
      new CustomEvent(ReproxyLinkRemoveEventTag, {
        detail: {
          minerId,
        } as IReproxyLinkEvent,
      })
    );
  }

  return {
    createPortAndOpen,
    deleteMinerPort,
  };
}
